import { PendingOnHubActions } from './components/Actions/PendingOnHubActions';
import { fmt } from 'IntlWrapper/IntlWrapper';

export const PENDING_ON_HUB_COLUMNS = [
  {
    title: fmt({
      id: 'ops_control.lost_orders.table_columns.order_id'
    }),
    dataIndex: 'order_id'
  },
  {
    title: fmt({
      id: 'ops_control.lost_orders.table_columns.current_hub'
    }),
    dataIndex: 'current_hub'
  },
  {
    title: fmt({
      id: 'ops_control.lost_orders.table_columns.flagged_by'
    }),
    dataIndex: 'flagged_by'
  },
  {
    title: fmt({
      id: 'ops_control.lost_orders.table_columns.sla'
    }),
    dataIndex: 'sla'
  },
  {
    width: '230px',
    render: (_, order) => <PendingOnHubActions order={order} />
  }
];

export const PENDING_ON_FLEET_COLUMNS = [
  {
    width: '230px',
    title: fmt({
      id: 'ops_control.lost_orders.table_columns.order_id'
    }),
    dataIndex: 'orderId'
  },
  {
    width: '230px',
    title: fmt({
      id: 'ops_control.lost_orders.table_columns.current_hub'
    }),
    dataIndex: 'currentHub'
  },
  {
    title: fmt({
      id: 'ops_control.lost_orders.table_columns.star'
    }),
    dataIndex: 'starName'
  },
  {
    title: fmt({
      id: 'ops_control.lost_orders.table_columns.proof'
    }),
    dataIndex: 'proof'
  },
  {
    width: '230px',
    dataIndex: 'actions'
  }
];

export const PENDING_ON_AUDIT_HUB_COLUMNS = [
  {
    width: '230px',
    title: fmt({
      id: 'ops_control.lost_orders.table_columns.order_id'
    }),
    dataIndex: 'orderId'
  },
  {
    width: '230px',
    title: fmt({
      id: 'ops_control.lost_orders.table_columns.current_hub'
    }),
    dataIndex: 'currentHub'
  },
  {
    title: fmt({
      id: 'ops_control.lost_orders.table_columns.flagged_by'
    }),
    dataIndex: 'flaggedBy'
  },
  {
    title: fmt({
      id: 'ops_control.lost_orders.table_columns.proof'
    }),
    dataIndex: 'proof'
  },
  {
    width: '230px',
    dataIndex: 'actions'
  }
];

export const PENDING_ON_AUDIT_FLEET_COLUMNS = [
  {
    width: '230px',
    title: fmt({
      id: 'ops_control.lost_orders.table_columns.order_id'
    }),
    dataIndex: 'orderId'
  },
  {
    width: '230px',
    title: fmt({
      id: 'ops_control.lost_orders.table_columns.current_hub'
    }),
    dataIndex: 'currentHub'
  },
  {
    width: '230px',
    title: fmt({
      id: 'ops_control.lost_orders.table_columns.star'
    }),
    dataIndex: 'starName'
  },
  {
    width: '230px',
    title: fmt({
      id: 'ops_control.lost_orders.table_columns.hub_proof'
    }),
    dataIndex: 'hubProof'
  },
  {
    width: '230px',
    title: fmt({
      id: 'ops_control.lost_orders.table_columns.fleet_justification'
    }),
    dataIndex: 'fleetJustification'
  },
  {
    width: '230px',
    dataIndex: 'actions'
  }
];

export const PENDING_ON_UNKNOWN_COLUMNS = [
  {
    width: '130px',
    title: fmt({
      id: 'ops_control.lost_orders.table_columns.order_id'
    }),
    dataIndex: 'orderId'
  },
  {
    width: '130px',
    title: fmt({
      id: 'ops_control.lost_orders.table_columns.current_hub'
    }),
    dataIndex: 'currentHub'
  },
  {
    width: '230px',
    title: fmt({
      id: 'ops_control.lost_orders.table_columns.flagged_by'
    }),
    dataIndex: 'flaggedBy'
  },
  {
    width: '430px',
    title: fmt({
      id: 'ops_control.lost_orders.table_columns.description'
    }),
    dataIndex: 'description'
  },
  {
    title: fmt({
      id: 'ops_control.lost_orders.table_columns.image'
    }),
    dataIndex: 'image'
  },
  {
    width: '230px',
    dataIndex: 'actions'
  }
];

export const CONFIRMED_LOST_COLUMNS = [
  {
    width: '230px',
    title: fmt({
      id: 'ops_control.lost_orders.table_columns.order_id'
    }),
    dataIndex: 'orderId'
  },
  {
    width: '230px',
    title: fmt({
      id: 'ops_control.lost_orders.table_columns.current_hub'
    }),
    dataIndex: 'currentHub'
  },
  {
    width: '230px',
    title: fmt({
      id: 'ops_control.lost_orders.table_columns.flagged_by'
    }),
    dataIndex: 'flaggedBy'
  },
  {
    width: '230px',
    title: fmt({
      id: 'ops_control.lost_orders.table_columns.marked_lost'
    }),
    dataIndex: 'markedLost'
  },
  {
    width: '230px',
    title: fmt({
      id: 'ops_control.lost_orders.table_columns.liable_on'
    }),
    dataIndex: 'liableOn'
  }
];
